const translations = {
  "en": {
    "(≈$%{var0}/mo)": "(≈$%{var0}/mo)",
    "Ed Complete Annual": "Ed Complete Annual"
  },
  "zh-tw": {
    "(≈$%{var0}/mo)": "(≈$%{var0}/月)",
    "Ed Complete Annual": "Ed Complete 年度"
  }
};

export default translations;
